import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

export const useIsLanding = () => {
  const pathname = usePathname();
  const isLanding = useMemo(() => pathname.includes('/promo/'), [pathname]);

  return { isLanding };
};
